import styled from '@emotion/styled';

export const Content = styled.div({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  minHeight: 0,
  height: '100%',
  overflow: 'hidden',
  position: 'relative',
  '@media screen and (max-width: 850px)': {
    overflow: 'visible',
  },
});
